var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WordCloudChart',_vm._b({attrs:{"request-status":_vm.requestStatus,"data":_vm.data,"title":_vm.title,"item-id":_vm.itemId,"card-options":_vm.customProps},on:{"reload":_vm.getData}},'WordCloudChart',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }